import { Component } from '@angular/core';
import { soundpostExchangeRateEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Exchange Rates') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostexchangerate-form',
    templateUrl: './soundpostexchangerate.form.component.html'
})
export class soundpostExchangeRateFormComponent extends BaseFormComponent {
    public record!: soundpostExchangeRateEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'payments', sectionName: 'Payments', isExpanded: false }
        ]);
    }
}

